import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('mescalina');

const MescalinaPage = () => <CaseStudyPage project={project} />;

export default MescalinaPage;
